<div class="flex flex-wrap justify-center align-center w-full">
  <!-- Left: Microphone level -->
  <div class="flex-[1_0_50%] flex gap-4 justify-center items-center min-w-75 p-4">
    <svg mib-microphone-icon class="h-8"></svg>
    <div class="w-full h-3 bg-gray-200 rounded">
      <div
        class="bg-mib-primary h-full rounded transition-all duration-200 ease-out"
        role="progressbar"
        [style.width.%]="(state()?.audioLevel || 0) * 100"
        aria-valuemin="0"
        aria-valuemax="100"></div>
    </div>
  </div>

  <!-- Right: Controls -->
  <div class="flex-[1_0_50%] min-w-75 p-4">
    <h5 class="mb-3 text-lg font-semibold max-md:text-center">Audio</h5>
    <p class="text-sm text-gray-700">
      Say something in the microphone to check that it is working.
    </p>

    <select
      class="mt-3 w-full border border-gray-300 rounded-md px-3 py-2 bg-white text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-primary"
      (change)="onChangeHandler($event)">
      @for (device of devices(); track device.deviceId) {
        <option [value]="device">
          {{ device.label || 'Unknown Microphone' }}
        </option>
      }
    </select>
  </div>
</div>
